import React from 'react';
import { Typography, Grid, Card, Avatar, Box } from '@mui/material';
import MainTitle from '../muiHome/mainTitle';
import { TableDataPresentation, ListDataPresentation } from '../../utils/utils';
import ImagesSlider from '../muiCommonComponent/imageSlider';
import CourseGrid from '../muiCommonComponent/coursesButtonGrid';

const companyLogos = [
    {img:'/assets/img/SOPS/company1.png'},
    {img:'/assets/img/SOPS/company2.png'},
    {img:'/assets/img/SOPS/company3.png'},
    {img:'/assets/img/SOPS/company4.png'},
    {img:'/assets/img/SOPS/company5.jpg'},
    {img:'/assets/img/SOPS/company6.png'},
    {img:'/assets/img/SOPS/company7.png'},
    {img:'/assets/img/SOPS/company8.png'},
    {img:'/assets/img/SOPS/company9.jpg'},
    {img:'/assets/img/SOPS/company10.png'},
    // Add more logo URLs as needed
];
function Home() {
const courses = [
  {name:'Bachelor of Pharmacy ',url:'/school-Of-pharmaceutical-sciences/b-pharma'},
  {name:'Diploma in Pharmacy ',url:'/school-Of-pharmaceutical-sciences/d-pharma'},
  {name:'Master of Pharmacy (Pharmaceutics)',url:'/school-Of-pharmaceutical-sciences/m-pharma'},
  {name:'Master of Pharmacy (Pharmacology)',url:'/school-Of-pharmaceutical-sciences/m-pharma'},
  {name:'Master of Pharmacy (Regulatory Affairs)',url:'/school-Of-pharmaceutical-sciences/m-pharma'},
  {name:'Pharm D',url:'#'}
]; 
  
  const offeredProgramme=[
    {'program':'B.A.LL.B.','duration':'5','Eligibility Criteria':'Senior Secondary or 10+2 or 12 th or equivalent from a recognised Board/ University with the minimum percentage as per BCI norms. Minimum 45% (GEN), 42% (OBC), and 40% (SC/ST).'},
    {'program':'B.B.A.LL.B','duration':'5','Eligibility Criteria':'Senior Secondary or 10+2 or 12 th or quivalent from a recognised Board/ University with the minimum percentage as per BCI norms.Minimum 45% (GEN), 42% (OBC), and 40% (SC/ST).'},
    {'program':'LL.B.','duration':'3','Eligibility Criteria':'Graduation or post-graduation from a recognised University with the minimum percentage as per BCI norms.Minimum 45% (GEN), 42% (OBC), and 40% (SC/ST).'},
    {'program':'LL.M.','duration':'1','Eligibility Criteria':'Law graduation from a recognised University with the minimum percentage as per UGC/ University norms.'},
]
const progHiglight=[
 {listName:' Comprehensive Curriculum Aligned with Industry Needs'},
 {listName:' Our curriculum is meticulously designed to blend foundational knowledge with modern pharmaceutical advancements, ensuring students are well-prepared for real-world challenges in research, healthcare and industry.'},
 {listName:' State-of-the-Art Laboratories'},
 {listName:' The School of Pharmacy houses cutting-edge laboratories for Pharmaceutics, Pharmacology, Pharmacognosy, Pharmaceutical Chemistry and Biotechnology, equipped with advanced instruments to foster hands-on learning and innovation.'},
  {listName:' Experienced and Research-Oriented Faculty'},
  {listName:' Our faculty comprises distinguished academicians and industry professionals with strong research backgrounds, committed to nurturing the next generation of pharmacy leaders through mentorship and academic excellence.'},
  {listName:' Strong Industry Linkages and Internships'},
  {listName:' Focus on Research and Innovation'},
  {listName:' Career-Oriented Training & Placements'},
  {listName:' Regular workshops, personality development programs, aptitude training, and mock interviews are conducted to enhance employability. Our dedicated placement cell ensures strong recruitment support across leading pharma and healthcare companies.'}
  
]
const eventOrgnized=[
  {img:'/assets/img/SOPS/newevent1.jpg'},
  {img:'/assets/img/SOPS/newevent2.jpg'},
  {img:'/assets/img/SOPS/newevent3.jpg'},
  {img:'/assets/img/SOPS/newevent4.jpg'},
  {img:'/assets/img/SOPS/newevent5.jpg'},
  {img:'/assets/img/SOPS/newevent6.jpg'},
  {img:'/assets/img/SOPS/newevent7.jpg'},
  {img:'/assets/img/SOPS/newevent8.jpg'},
  {img:'/assets/img/SOPS/newevent9.jpg'},
  {img:'/assets/img/SOPS/newevent10.jpg'},
]
const strengths=[
  {listName:'ExpertFaculty - Our team comprises highly qualified and experienced faculty members who bring a unique blend of academic excellence and industry insight. Their guidance ensures a comprehensive and practical learning experience for students.'},
  {listName:'Industry Collaboration - We maintain robust partnerships with leading pharmaceutical companies, facilitating internships, placements and collaborative research. These connections provide our students with invaluable hands-on exposure and real-world learning opportunities.'},
  {listName:'State-of-the-Art Laboratories - Our institution houses modern laboratories equipped with cutting-edge instrumentation and facilities. This enables students to perform advanced experiments and research aligned with current industry standards and global best practices.'},
  {listName:'Focus on Research & Innovation - We foster a culture of research and innovation, encouraging both students and faculty to pursue pioneering research initiatives that drive the future of pharmaceutical sciences.'},
  {listName:'Dedicated Placement Support - A proactive placement cell supports students with internships, job placements, and career guidance. Our strong industry ties help graduates secure roles in top-tier pharmaceutical companies.'},
  {listName:'Global Exposure - Students are encouraged to participate in international conferences, seminars, and academic exchange programs. These initiatives promote a global outlook and facilitate international networking within the pharmaceutical community.'},
  {listName:'Impressive Research Output - Our faculty members have published over 100 research papers in reputed national and international journals indexed in SCI, SCI-E, Scopus, PubMed and Web of Science (WoS), reflecting our strong academic and research foundation.'}
    
]
const knowledge=[
  {listName:'Multi Commodity Exchange of India Limited (MCX)'},
 {listName:'ICAI, Northern India Regional Council Faridabad Chapter.'},
]
const awardImage=[
  {img:'/assets/img/SOPS/award1.jpg'},
  {img:'/assets/img/SOPS/award2.jpg'},
  {img:'/assets/img/SOPS/award3.jpg'},
  {img:'/assets/img/SOPS/award4.jpg'},
]
const mediaImage=[
  {img:'/assets/img/SOPS/media1.jpg'},
  {img:'/assets/img/SOPS/media2.jpg'},
  {img:'/assets/img/SOPS/media3.jpg'},
  {img:'/assets/img/SOPS/media4.jpg'},
  {img:'/assets/img/SOPS/media5.jpg'},
  {img:'/assets/img/SOPS/media6.jpg'},
  {img:'/assets/img/SOPS/media7.jpg'},
  {img:'/assets/img/SOPS/media8.jpg'},
  {img:'/assets/img/SOPS/media9.jpg'},
  {img:'/assets/img/SOPS/media10.jpg'},
  {img:'/assets/img/SOPS/media11.jpg'},
  {img:'/assets/img/SOPS/media12.jpg'},
  {img:'/assets/img/SOPS/media13.jpg'},
  {img:'/assets/img/SOPS/media14.jpg'},
  {img:'/assets/img/SOPS/media15.jpg'},
  {img:'/assets/img/SOPS/media16.jpg'},
  {img:'/assets/img/SOPS/media17.jpg'},
  {img:'/assets/img/SOPS/media18.jpg'},
  {img:'/assets/img/SOPS/media19.jpg'},
  {img:'/assets/img/SOPS/media20.jpg'},
  {img:'/assets/img/SOPS/media21.jpg'},
 
]
const grandRecived=[
  {img:'/assets/img/SOPS/grant1.jpg'},
]
const studentArr=[
  {img:'/assets/img/SOPS/student1.jpg'},
  {img:'/assets/img/SOPS/student2.jpg'},
  {img:'/assets/img/SOPS/student3.jpg'},
  {img:'/assets/img/SOPS/student4.jpg'},
  {img:'/assets/img/SOPS/student5.jpg'},
  {img:'/assets/img/SOPS/student6.jpg'},
  {img:'/assets/img/SOPS/student7.jpg'},
]
const feeArr=[
  //{'Courses':'B. Pharmacy ','duration':'4','Tuition Fee':'130000','1 year Onwards fees':'147000'},
  {'Courses':'D. Pharmacy ','eligibility ':'10+2 WITH 50% MARKS IN PCB/M','duration':'2','Tuition Fee':'70000','1 year Onwards fees':'90000'},
  {'Courses':'B. Pharmacy', 'eligibility ':'10+2 WITH 50% MARKS IN PCB/M (Age 17 Years)','duration':'4','Tuition Fee':'130000','1 year Onwards fees':'150000'},
  {'Courses':'Pharm. D', 'eligibility ':'10+2 WITH 50% MARKS IN PCB/M','duration':'6','Tuition Fee':'175000','1 year Onwards fees':'195000'},
  {'Courses':'M. Pharmacy (Pharmaceutics, Pharmacology)', 'eligibility ':'B.Pharmacy with 55% marks','duration':'2','Tuition Fee':'1,07,000','1 year Onwards fees':'127000'},
  {'Courses':'Note: Pharma D (5 Years + 1 Year Training)', 'eligibility ':'', 'duration':'','Tuition Fee':'','1 year Onwards fees':''},
  
]
const hostalFeeData=[
  {item:'Triple Seater (Non AC) with Meal','fee':'₹ 96000/-'},
  {item:'Triple Seater (AC) with Meal','fee':'₹130000/-'}
]
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="School of Pharmaceutical Sciences" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="ABOUT SCHOOL OF PHARMACEUTICAL SCIENCES" />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        Pharmacy education in India plays a vital role in producing skilled professionals who contribute significantly to the healthcare system. With advancements in healthcare and evolving pharmaceutical industries, it becomes imperative to continuously enhance the pharmacy programme to meet the demands of the modern world. Pharmacy education encompasses various programs tailored to equip students with the necessary knowledge and skills to excel in the pharmaceutical industry.
        <br/>
        <br/>
        The School of Pharmaceutical Sciences (SOPS) started its first batch of B.Pharmacy course in 2015, D.Pharmacy course in 2016, M.Pharmacy course in 2021& Pharm. D course in 2024has been successfully marching ahead since inception. It is one of the fastest-growing leading pharmacy institutions in North India, providing air-conditioned class rooms, a Wi-Fi-enabled campus, and more than 7000 books in the pharmacy library with special emphasis on practical exposure for the students. Facilities available include a Central Instrumentation facility lab, Industrial Pharmacy lab, Pharmacology labs, Pharmacognosy labs, and Pharmaceutical Chemistry labs fully loaded with the latest models of machinery and instruments, which is very useful from the research point of view. SOPS is one of the many successful ventures of MVN University, Palwal (Haryana), which has a reputation for pioneering in pursuit of academic excellence. SOPS, in pursuit of its vision, is providing outstanding educational experiences in pharmacy and practice in a supportive environment of scholarship, research, and integrity.
<br/>
  <br/>
  <b color='red'>We are your home for the healthier life.</b>
</Typography>
</Grid>

<Grid item xs={12} sm={12} md={12}>
        <MainTitle title="DEAN’S MESSAGE" />
      </Grid>

<Grid item xs={12} sm={4} md={4}>
        <Card sx={{ height: 'auto', padding: '10px', boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', borderRadius: '10px' }}>
          <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
            <Avatar alt={'NP'} src={'/assets/img/SOPS/ashutoshupadhayay.jpg'} sx={{ width: 150, height: 150, marginBottom: 2 }} />
            <Box sx={{ background: '#ED1E24', borderRadius: '10px', padding: 2 }}>
              <Typography fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" color={'#fff'}>
              Dr. Ashutosh Upadhayay
              </Typography>
              <Typography fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" color={'#fff'}>
              Dean of School of Pharmaceutical Sciences
              </Typography>
            </Box>
          </Box>
        </Card>
      </Grid>
      <Grid item xs={12} sm={8} md={8}>
        <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        Welcome to the School of Pharmaceutical Sciences (SOPS), MVN University, Palwal. As a Dean and Professor, I am delighted to invite you to join our esteemed institution, where we are dedicated to nurturing future leaders in the field of pharmaceutical sciences.
<br/><br/>
Our comprehensive curriculum, state-of-the-art laboratories, and experienced faculty ensure a robust educational experience. We focus on innovative research, hands-on learning, and industry collaborations to equip you with the skills necessary to excel in this dynamic field.
<br/><br/>
At MVN, we emphasize holistic development, encouraging critical thinking, ethical practices, and a commitment to lifelong learning. Your journey with us will be transformative, preparing you to meet global healthcare challenges with confidence and competence.
<br/><br/>
I look forward to seeing you thrive and contribute meaningfully to the world of pharmaceuticals.
  
        </Typography>
      </Grid>

 
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="School of Pharmaceutical Sciences Courses" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
        <CourseGrid courses={courses}/>
      {/* <TableDataPresentation data={offeredProgramme}/> */}
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="PROGRAM HIGHLIGHTS" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12} textAlign='justify' >
      <ListDataPresentation DataList={progHiglight} textAlign='justify' />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="Events Organized" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <ImagesSlider imgArr={eventOrgnized} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="MEDIA COVERAGE" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <ImagesSlider imgArr={mediaImage} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="AWARD HIGHLIGHTS" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <ImagesSlider imgArr={awardImage} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="STRENGTHS OF SCHOOL OF PHARMACEUTICAL SCIENCES" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <ListDataPresentation DataList={strengths}/>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="GRANTS RECIEVED" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <ImagesSlider imgArr={grandRecived} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="KNOWLEDGE PARTNERS / COLLABORATION" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <MainTitle title="MoU with Sarvodaya Hospital, Faridabad" />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        MVN University, Palwal, and Sarvodaya Hospital, Faridabad, have inked an MOU. Thrilled to embark on this collaborative journey towards excellence in pharmaceutical education and healthcare.  #MVNUniversity #SarvodayaHospital #Training #Partnership #HealthcareEducation
</Typography>
<ImagesSlider imgArr={[{img:'/assets/img/SOPS/knowledge1.jpg'},{img:'/assets/img/SOPS/knowledge2.jpg'}]} />
</Grid>
<Grid item xs={12} sm={12} lg={12} md={12}>
      <MainTitle title="MoU with CFC Pharma Cluster Pvt Ltd, Karnal" />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        MVN University, Palwal, achieves another milestone with a successful #MOU with CFC Pharma Cluster Pvt Ltd, Karnal!  This collaboration opens doors for impactful research projects and enriching training opportunities for our dedicated faculty members and students.  #MVNUniversity #CFCPharmaCluster #ResearchCollaboration #AcademicExcellence
</Typography>
<ImagesSlider imgArr={[{img:'/assets/img/SOPS/knowledge3.jpg'},{img:'/assets/img/SOPS/knowledge4.jpg'}]} />
</Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="Top Recruiters" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <ImagesSlider imgArr={companyLogos} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="STUDENT TESTIMONIALS" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <ImagesSlider imgArr={studentArr} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <MainTitle title="FEE STRUCTURE – 2026-27" />
      </Grid>
      <Grid item xs={12} sm={12} lg={12} md={12}>
      <TableDataPresentation data={feeArr}/>
      </Grid>
      <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    Hostel Fee
    </Typography>
    <TableDataPresentation data={hostalFeeData}/>
    </Grid>
    {/* <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <b>Note:</b> Hostel Caution Money of ₹10,000/- One Time Payment (Refundable)
    <br/> <br/>
    </Typography>
    </Grid> */}
    </Grid>
   
  );
}

export default Home;
